import { useEffect, useState } from "react";
import { Button, Col, Flex, Row, Space, Table, Tag, Tooltip, Typography } from "antd";
import { callCreateDashboardPhone, callGetDashboardPhones, callUpdateDashboardPhone } from "../../../../services/phonesService";
import { showNotificationTopEnd } from "../../../../util/utils";
import { DASHBOARD_PHONES } from "../../../../constants/AppConstants";
import { EditOutlined } from "@ant-design/icons";
import PhonesModalForm from "../PhonesModalForm/PhonesModalForm";

const { Title } = Typography;


export default function PhonesList() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalCreateVisible, setModalCreateVisible] = useState(false);
    const [reload, setReload] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });


    useEffect(() => {
        getPhones(pagination.current - 1, pagination.pageSize);
        // eslint-disable-next-line
    }, [reload]);


    const getPhones = async (page, size) => {
        setLoading(true);

        const response = await callGetDashboardPhones(page, size);
        if (response?.status === 200) {
            setData(response.data.content);
            setPagination({
                current: page + 1,
                pageSize: size,
                total: response.data?.page?.totalElements,
            });
        } else {
            showNotificationTopEnd("error", "Error, por favor recarga la pagina");
        }
        setLoading(false);
    };


    const handleTableChange = (pagination) => {
        getPhones(pagination.current - 1, pagination.pageSize);
    };


    const handleEdit = (record) => {
        setSelectedRecord(record);
        setModalCreateVisible(true);
    };


    const columns = [
        {
            title: DASHBOARD_PHONES.COLUMNS.ID,
            dataIndex: "phoneId",
            key: "phoneId",
            width: 80,
        },
        {
            title: DASHBOARD_PHONES.COLUMNS.LADA,
            dataIndex: "lada",
            key: "lada",
        },
        {
            title: DASHBOARD_PHONES.COLUMNS.PHONE,
            dataIndex: "phoneNumber",
            key: "phoneNumber",
        },
        {
            title: DASHBOARD_PHONES.COLUMNS.OWNER_NAME,
            dataIndex: "ownerName",
            key: "ownerName",
        },
        {
            title: DASHBOARD_PHONES.COLUMNS.WHATSAPP_PHONE_ID,
            dataIndex: "whatsAppPhoneId",
            key: "whatsAppPhoneId",
            render: (text) => (
                <Tooltip title={text}>
                    {text && text.length > 20 ? `${text.slice(0, 20)}...` : text}
                </Tooltip>
            ),
        },
        {
            title: DASHBOARD_PHONES.COLUMNS.MAIN,
            dataIndex: "main",
            key: "main",
            render: (value) =>
                value ? (
                    <Tag color="blue">{DASHBOARD_PHONES.STATUS.MAIN}</Tag>
                ) : (
                    <Tag color="gold">{DASHBOARD_PHONES.STATUS.SECONDARY}</Tag>
                ),
        },
        {
            title: DASHBOARD_PHONES.COLUMNS.STATUS,
            dataIndex: "active",
            key: "active",
            render: (value) =>
                value ? (
                    <Tag color="green">{DASHBOARD_PHONES.STATUS.ACTIVE}</Tag>
                ) : (
                    <Tag color="red">{DASHBOARD_PHONES.STATUS.INACTIVE}</Tag>
                ),
        },
        {
            title: DASHBOARD_PHONES.COLUMNS.ACTIONS,
            key: "active",
            render: (_, record) => (
                <Space>
                    <Tooltip title={DASHBOARD_PHONES.ACTIONS.TOOLTIPS.EDIT}>
                        <Button
                            shape="circle"
                            icon={<EditOutlined />}
                            type="primary"
                            onClick={() => handleEdit(record)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];


    return (
        <Flex vertical>
            <Row
                gutter={[16, 16]}
                justify="space-between"
                align="middle"
                style={{ marginBottom: 24 }}
            >
                <Col span="auto">
                    <Title level={3}>{DASHBOARD_PHONES.TITLE}</Title>
                </Col>
                <Col span="auto">
                    <Button
                        color="green"
                        variant="solid"
                        onClick={() => setModalCreateVisible(true)}
                    >
                        {DASHBOARD_PHONES.ACTIONS.CREATE_TITLE}
                    </Button>
                    <PhonesModalForm
                        visible={modalCreateVisible}
                        onClose={() => {
                            setModalCreateVisible(false);
                            setSelectedRecord(null);
                            setReload(!reload);
                        }}
                        initialValues={selectedRecord}
                        onSubmit={(values) =>
                            selectedRecord
                                ? callUpdateDashboardPhone(values)
                                : callCreateDashboardPhone(values)
                        }
                    />
                </Col>
            </Row>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="phoneId"
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
            />
        </Flex>
    );
}